/* eslint-disable import/no-unresolved */
import React from 'react';

import RightModalLayout from '../../../../../../../../layouts/Modal/RightModalLayout';
import CardMC from '../../../../../../../../components/CardMC';
import IconMC from '../../../../../../../../components/IconMC';

const GetCustomerCrmDataToolView = ({
  t,
  footerSubmitLabel,
  handleBack,
  handleConfirmGetCustomerCrmData,
  crmFieldOptions,
  crmFieldsLoading,
  selectedCrmFieldIds,
  toggleCrmFieldId
}) => {
  const selectedCount = selectedCrmFieldIds?.length || 0;
  const canSubmit = selectedCount > 0;

  return (
    <RightModalLayout
      closeAction={handleBack}
      title={t('tools.get_customer_crm_data_title')}
      showBackButton
      submitLabel={footerSubmitLabel}
      submitAction={handleConfirmGetCustomerCrmData}
      cancelLabel={t('Common:actions.cancel')}
      cancelAction={handleBack}
      footerVariant="VERTICAL"
      submitDisabled={!canSubmit}
    >
      <div className="tw-flex tw-flex-col tw-gap-3">
        <div className="tw-text-xs tw-text-gray-600">
          {t('tools.get_customer_crm_data_picker_help')}
        </div>
        <div className="tw-text-xs tw-text-gray-500">
          {t('tools.selected_count', { count: selectedCount })}
        </div>

        {crmFieldsLoading && (
          <div className="tw-text-xs tw-text-gray-500">
            {t('tools.get_customer_crm_data_loading')}
          </div>
        )}

        <div className="tw-flex tw-flex-col tw-gap-2">
          {(crmFieldOptions || []).map((field) => {
            const checked = selectedCrmFieldIds?.includes?.(field.id);
            return (
              <CardMC
                key={field.id}
                className={`tw-p-3 tw-flex tw-items-center tw-justify-between tw-cursor-pointer hover:tw-bg-gray-50 ${
                  checked ? 'tw-bg-gray-50 !tw-border-gray-300' : ''
                }`}
                onClick={() => toggleCrmFieldId(field.id)}
              >
                <div className="tw-min-w-0">
                  <div className="tw-text-sm tw-font-medium tw-text-gray-900 tw-truncate">
                    {field.label}
                  </div>
                  <div className="tw-text-[11px] tw-text-gray-500 tw-font-mono tw-truncate">
                    {field.id}
                  </div>
                </div>
                <div className="tw-shrink-0">
                  {checked ? (
                    <IconMC name="checkmark-circle-2-fill" className="tw-text-blue-500" />
                  ) : (
                    <IconMC name="circle-outline" className="tw-text-gray-300" />
                  )}
                </div>
              </CardMC>
            );
          })}
        </div>

        {!crmFieldsLoading && (!crmFieldOptions || crmFieldOptions.length === 0) && (
          <div className="tw-text-xs tw-text-gray-500">
            {t('tools.get_customer_crm_data_empty')}
          </div>
        )}
      </div>
    </RightModalLayout>
  );
};

export default GetCustomerCrmDataToolView;
